import {Container} from '@mui/material';
import './App.css';
import SelectTemplate from './components/SelectTemplate';
function App() {
    return (
        <Container maxWidth="md">
            <SelectTemplate/>
        </Container>
    );
}

export default App;
